import { render, staticRenderFns } from "./SuccessionFileForm.vue?vue&type=template&id=a6e014a4&"
import script from "./SuccessionFileForm.vue?vue&type=script&lang=js&"
export * from "./SuccessionFileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports